// lbl.register.

export const register = {
    prefix_list: [
        {
            text: 'นาย',
            value: 'mr',
        },
        {
            text: 'นาง',
            value: 'ms',
        },
        {
            text: 'นางสาว',
            value: 'mrs',
        },
    ],
    prefix: {
        name: '',
        placeholder: '',
        required: 'กรุณาระบุเพศของคุณ',
        too_short: '',
        invalid: '',
    },
    firstname: {
        name: 'ชื่อจริง',
        placeholder: 'ชื่อจริง',
        required: 'กรุณาระบุชื่อ',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: 'นามสกุล',
        required: 'กรุณาระบุนามสกุล',
        too_short: '',
        invalid: '',
    },
    contactNumber: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'เบอร์โทรศัพท์',
        required: 'กรุณาระบุหมายเลขโทรศัพท์มือถือ 10 หลัก',
        too_short: 'กรุณาระบุหมายเลขโทรศัพท์มือถือ 10 หลัก',
        invalid: 'Incorrect contact number format',
    },
    email: {
        name: 'อีเมล',
        placeholder: 'อีเมล',
        required: 'กรุณาระบุอีเมล',
        too_short: '',
        invalid: 'Incorrect email format',
    },
    birthdate: {
        name: 'วันเกิด',
        placeholder: 'วันเกิด',
        required: '',
        too_short: '',
        invalid: '',
    },
    term_market_1:'ฉันสนใจและต้องการรับข้อมูลข่าวสารเกี่ยวกับสินค้า บริการ ของแถม ส่วนลด โปรโมชั่น และกิจกรรมต่างๆ ที่เกี่ยวข้องจาก เบอร์เกอร์คิง และ ',
    term_market_2:'บริษัทในเครือและแบรนด์ที่เกี่ยวข้อง',
    term_cancel: '* คุณสามารถถอนความยินยอมได้ทุกเมื่อ โดยส่งอีเมลมาที่',
    warnning_next: 'คุณได้ยืนยันว่าได้อ่านและยอมรับ',
    warnning_next_2: 'และ',
    warnning_next_3: 'ของ บริษัท เบอร์เกอร์ (ประเทศไทย) จำกัด แล้ว',
    term: 'ข้อกำหนดการใช้งาน',
    privacy: 'คำชี้แจงว่าด้วยความเป็นส่วนตัว',
    register: 'สมัครบัญชีผู้ใช้',
    otp_popup: {
        title: 'กรอก OTP ที่ได้รับจากหมายเลขโทรศัพท์ที่ลงทะเบียนไว้',
        refcode: 'รหัสอ้างอิง',
        estimated: 'เวลา :',
        min: 'นาที',
        did_not_otp: 'ไม่ได้รับ OTP? ',
        resend: 'ส่งอีกครั้ง',
        confirm: 'ยืนยัน',
        invalid_otp: 'รหัส OTP ไม่ถูกต้อง'
    },
    
    setup_pin: 'ตั้งค่า PIN',
    enter_pin: 'กรอก PIN',
    confirm_pin: 'ยืนยัน PIN',
    pin_not_match: 'รหัสผ่านไม่ตรงกัน กรุณาลองใหม่อีกครั้ง',

    register_completed: 'สมัครสมาชิกสำเร็จ',
    Now_you: 'คุณเป็นสมาชิก',
    burgerking: 'BURGER KING®',
    enjoy_your_meal: 'แล้ว ขอให้มีความสุขกับมื้ออาหาร',
    start_your_order: 'เริ่มต้นสั่งอาหาร',

    reset_password: {
        title: 'ตั้งค่า PIN ใหม่',
        msg: "ป้อนหมายเลขโทรศัพท์มือถือที่เชื่อมโยงกับบัญชีของคุณ แล้วเราจะส่งข้อความพร้อมคำแนะนำในการรีเซ็ต PIN มือถือของคุณ",
        send: 'ส่ง',
        birthdate_not_match: 'คุณใส่วันเกิดไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
        success: 'ระบบได้ส่งลิงค์ในการรีเซตรหัสผ่านของคุณแล้ว',
    },

    change_pin_title: {
        enter_pin: 'กรุณาใส่ PIN',
        confirm_pin: 'ยืนยัน PIN',
    },

    forgot_popup: {
        msg_1: 'คุณต้องการส่งข้อความพร้อมคำแนะนำในการรีเซ็ต PIN ของคุณเป็นหมายเลขโทรศัพท์มือถือ หรืออีเมล',
        msg_2: "what'd you like to do",
        mobile: 'เบอร์โทรศัพท์',
        email: 'อีเมล'
    },

    error_email_duplicate: 'อีเมลของคุณซ้ำกับในระบบ กรุณาลองใหม่อีกครั้ง',
    error_mobile_duplicate: 'เบอร์โทรศัพท์ของคุณซ้ำกับในระบบ กรุณาลองใหม่อีกครั้ง',

    traces_title: 'ฟรีคราวพอยท์!',
    traces_msg: "ยินดีด้วย! คุณได้รับ {0} คราวพอยท์",
    traces_btn: 'ไปที่หน้าของรางวัล!',

    badges_title: 'ฟรีของรางวัล!',
    badges_name: 'ยินดีด้วย! คุณได้รับของรางวัลวอเชอร์ฟรี! {0}',
    badges_btn: 'ไปที่หน้าของรางวัล!'
};
